/*
 * @Author: zhangweinan
 * @Date: 2022-10-08 16:29:28
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-04-10 16:36:33
 * @Description:  用户管理
 * @FilePath: /manage_property/src/data/ApiPersonnel.js
 */
import accountManager from '@/utils/account';
import request from '@/core/request.js';

export const loginTypesMap = {
  1: 'system',
  3: 'government',
  4: 'enterprise',
  5: 'operation',
};

const loginTypeToType = (type) => {
  return loginTypesMap[type || accountManager.getLoginType()] || 'enterprise';
};

//用户列表
export const getPersonnel = (params, type) => {
  let url;
  switch (type) {
    case 'system':
      url = '/auser-entity/getAllUsersInfo';
      break;
    case 'enterprise':
      url = '/euser/queryPage';
      break;
    case 'government':
      url = '/guser/queryPage';
      break;
    case 'operation':
      url = '/muser/queryPage';
      break;
    case 'im': // IM用户
      url = '/cuser/queryPage';
      break;
    default:
      url = '/auser-entity/getAllUsersInfo';
  }
  return request({
    url,
    method: 'get',
    params,
  });
};

// 用户注册
export const registryPersonnel = (data, type) => {
  let url;
  switch (type) {
    case 'enterprise':
      url = 'euser/register';
      break;
    default:
      url = 'euser/register';
  }

  return request({
    url,
    method: 'post',
    data,
  });
};

// 用户新增
export const addPersonnel = (data, type) => {
  let url;
  switch (type) {
    case 'system':
      url = '/auser-entity/addUsers';
      break;
    case 'enterprise':
      url = '/euser/add';
      break;
    case 'government':
      url = '/guser/add';
      break;
    case 'operation':
      url = '/muser/add';
      break;
    default:
      url = '/auser-entity/addUsers';
  }

  return request({
    url,
    method: 'post',
    data,
  });
};

// 用户认证
export const certificatePersonel = (data) => {
  return request({
    url: '/euser/authentication',
    method: 'post',
    data,
  });
};

// 用户信息修改
export const euserEdit = (data) => {
  return request({
    url: '/euser/edit',
    method: 'post',
    data,
  });
};

// 投诉
export const complaintCreate = (data) => {
  return request({
    url: '/complaint/create',
    method: 'post',
    data,
  });
};

// 用户编辑
export const updatePersonnel = (data, loginType) => {
  let url;
  const type = loginTypeToType(loginType);
  switch (type) {
    case 'system':
      url = '/auser-entity/updateUsersInfo';
      break;
    case 'enterprise':
      url = '/euser/edit';
      break;
    case 'government':
      url = '/guser/edit';
      break;
    case 'operation':
      url = '/muser/edit';
      break;
    default:
      url = '/auser-entity/updateUsersInfo';
  }
  return request({
    url,
    method: 'post',
    data,
  });
};

// 用户删除
export const delPersonnel = ({ ids }, type) => {
  let url;
  switch (type) {
    case 'system':
      url = '/auser-entity/batchDelete';
      break;
    case 'enterprise':
      url = '/euser/deleteBatch';
      break;
    case 'government':
      url = '/guser/deleteBatch';
      break;
    case 'operation':
      url = '/muser/deleteBatch';
      break;
    default:
      url = '/auser-entity/batchDelete';
  }
  if (type === 'system' || !type) {
    let idList = '';
    ids.forEach((item, i) => {
      const dot = i ? '&' : '';
      idList = idList + dot + `ids=${item}`;
    });
    return request({
      url: `${url}?${idList}`,
      method: 'post',
    });
  } else {
    return request({
      url: url,
      method: 'post',
      data: ids,
    });
  }
};

// 用户组列表
export const getAllUsersGroup = (params) =>
  request({
    url: '/users-group-entity/getAllUsersGroup',
    method: 'get',
    params,
  });

// 用户组新增
export const addUsersGroup = (data) =>
  request({
    url: '/users-group-entity/addUsersGroup',
    method: 'post',
    data,
  });

// 用户组更新
export const updateUsers = (data) =>
  request({
    url: '/users-group-entity/updateUsers',
    method: 'post',
    data,
  });

// 不分页用户组
export const getAllUsersGroupNoPage = (params) =>
  request({
    url: '/users-group-entity/getAllUsersGroupNoPage',
    method: 'get',
    params,
  });

//图片上传
export const uploadFile = (params) => {
  return request({
    url: '/Upload/upload',
    method: 'post',
    params,
  });
};
//选择区域
export const selectOrg = (params) =>
  request({
    url: `/org-entity/selectOrg?accountId=${params.accountId}&orgId=${params.orgId}`,
    method: 'get',
    //params
  });

// 修改密码
export const updatePassWord = (data) =>
  request({
    url: '/account-entity/updatePassWord',
    method: 'post',
    data,
  });
//
export function exportExcel(type) {
  console.log(type);
  let url;
  let method = 'post';
  switch (type) {
    case 'system':
      url = '/auser-entity/exportExcel';
      method = 'get';
      break;
    case 'enterprise':
      url = '/euser/exportExcel';
      break;
    case 'government':
      url = '/guser/exportExcel';
      break;
    case 'operation':
      url = '/muser/exportExcel';
      break;
    default:
      url = '/auser-entity/exportExcel';
  }
  return request({
    url,
    method,
    responseType: 'blob',
  });
}

//申请试用
export const euserApply = (data) => {
  return request({
    url: '/euser/apply',
    method: 'post',
    data,
  });
};
